import { useEffect, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { useNotificationsStore } from '@thermon-platforms/thermon-ui-core';
import useDevicesStore from 'store/devices';
import { getConfigItem } from 'util/device';
import api from 'util/api';

function Firmware() {
  const [file, setFile] = useState();
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState();
  const [processing, setProcessing] = useState(false);
  const [, notificationsStoreActions] = useNotificationsStore();
  const [devicesStore, devicesStoreActions] = useDevicesStore();
  const [availablePackages, setAvailablePackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState();
  const site = devicesStore.devices.find(d => d.type == 'Site');
  const [detail, setDetail] = useState();
  let currentVersion = getConfigItem(detail, 'FirmwareVersion');
  let updatedDate = getConfigItem(detail, 'FirmwareDate');

  useEffect(() => {
    setLoading(true)
    queryStatus()
      .then(async res => {
        const status = await res.json();
        if (status.statusLabel == 'Pending' || status.statusLabel == 'InProgress') {
          setProgress(status.progress)
          setProcessing(true);
          pollStatus();
        }
      })
      .finally(() => {
        setLoading(false);
      });

    api('/firmware').then(async res => {
      setAvailablePackages(await res.json());
    });

    devicesStoreActions.fetchDetail(site?.id)
      .then(res => setDetail(res));
  }, []);

  function queryStatus() {
    return api(`/firmware/status/${site?.id}`);
  }

  function pollStatus() {
    queryStatus()
      .then(async res => {
        const status = await res.json();
        if (progress == 100) {
          setProgress(undefined);
          setProcessing(false);
          return;
        };
        if (status.statusLabel == 'Pending' || status.statusLabel == 'InProgress') {
          setProgress(status.progress);
          setProcessing(true);
          setTimeout(() => {
            pollStatus();
          }, 15 * 1000);
        }
      });
  }

  function handleChange(event) {
    setFile(event.target.files[0]);
  }

  function handleUpload() {
    const formData = new FormData();
    formData.append('FirmwareFile', file, file.name);
    setLoading(true);

    api(`/firmware/upload`, {
      method: 'PUT',
      body: formData,
      headers: {
        // This is an awkward hack to remove the Content-Type
        // header which let's the browser select the correct
        // type for upload. Unfortunately, just setting it to
        // multipart/form-data; doesn't work
      }
    })
      .then(() => {
        setFile(undefined);
        pollStatus();
      })
      .catch(() => {
        notificationsStoreActions.notify(
          t`Upload failed`,
          'alert'
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function cancel() {
    api('/firmware/cancel', {method: 'PUT'})
      .then(() => {
        notificationsStoreActions.notify(
          t`Firmware update successfully canceled`,
          'ok'
        );

        setProgress(undefined);
        setProcessing(false);
      })
      .catch(() => {
        notificationsStoreActions.notify(
          t`Canceling firmware update failed`,
          'alert'
        );
      });
  }

  function handleApplyPackage() {
    setLoading(true);
    api(`/firmware/apply?firmwareFile=${encodeURIComponent(selectedPackage)}`, {method: 'PUT'})
      .then(() => {
        pollStatus();
      })
      .catch(() => {
        notificationsStoreActions.notify(
          t`Applying firmware package failed`,
          'alert'
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return(
    <div className="update-firmware">
      <h3><Trans>Update Firmware</Trans></h3>
      <ul className="form">
        <li>
          <p>
            <strong><Trans>Current Firmware Version</Trans></strong>:&nbsp;
            {currentVersion?.value}
          </p>
          <p>
            <strong><Trans>Firmware Updated On</Trans></strong>:&nbsp;
            {updatedDate ? new Date(updatedDate?.value).toLocaleString() : <></>}
          </p>
        </li>
        <li>
          <label htmlFor="firmware-upload">
            {!processing ?
              <Trans>Select File</Trans> :
              <Trans>Updating...</Trans>
            }
          </label>
          {!processing ?
            <input
              type="file"
              id="firmware-upload"
              accept=".genesispackage"
              onChange={handleChange}
              disabled={loading}
            /> :
            <div className="progress-indicator">
              <span style={{width: `${progress}%`}}>{progress}%</span>
            </div>
          }
          {!processing ? <button
            disabled={!file || loading}
            onClick={handleUpload}
          >
            <Trans>Upload</Trans>
          </button> : <></>}
          {processing ? <button
            className={`processing`}
            onClick={cancel}
          >
            <Trans>Cancel</Trans>
          </button> : <></>}
        </li>
        {!processing && availablePackages.length ? <li>
          <label htmlFor="firmware-packages">
            <Trans>Available Firmware Packages</Trans>
          </label>
          <select
            id="firmware-packages"
            onChange={e => setSelectedPackage(e.target.value)}
          >
            <option value=""><Trans>Select a package</Trans></option>
            {availablePackages.map(pkg => (
              <option key={pkg.value} value={pkg.value}>{pkg.label}</option>
            ))}
          </select>
          <button
            disabled={!selectedPackage || loading}
            onClick={handleApplyPackage}
          >
            <Trans>Apply</Trans>
          </button>
        </li> : <></>}
      </ul>
    </div>
  );
}

export default Firmware;
